import JSX from "../../helpers/react.js";
import {IOneAppJson} from "../../../../../nodeserver/structs/database";

function UserData({user}: { user: IOneAppJson['owner'] }) {
    return (
        <div className="user">
            <a href={"/users/id" + user.id}>
                <img className="bordered" src={user.avatars.big} alt="avatar" width="130" height="130"/>
            </a>
            <a className="name" href={"/users/id" + user.id}>{user.nickname}</a>
        </div>
    )
}

export function DevApp({app}: { app: IOneAppJson }) {
    return (
        <div className="dev-app">
            <UserData user={app.owner}/>
            {
                userRoles.includes('root') || userRoles.includes('admin') || user_id == app.owner.id ?
                    <a className="app-content" href={"/dev/applications/" + app.app_id}>
                        <p className="name">{app.name}</p>
                        <p className="description">{app.description}</p>
                        <p className="create-date">Дата создания: <local-time data-time={app.created_at}></local-time></p>
                    </a>
                    :
                    <p className="app-content" href={"/dev/applications/" + app.app_id}>
                        <p className="name">{app.name}</p>
                        <p className="description">{app.description}</p>
                        <p className="create-date">Дата создания: <local-time data-time={app.created_at}></local-time></p>
                    </p>
            }
        </div>
    )
}